import gql from 'graphql-tag';

import type { QuestionType, ValidationInputType } from 'bundles/survey-form/constants/SurveyFormConstants';

type QuestionContent = {
  options: any[];
  validations: Record<ValidationInputType, {}>[];
  prompt: string;
};

type Question = {
  isRequired: boolean;
  content: Record<QuestionType, QuestionContent>;
  id: string;
  displayHalfLine: boolean;
};

type Definition = {
  questions: Question[];
  nextMessage: string;
  title: string;
};

type Section = {
  typeName: string;
  definition: Definition;
};

export type PreviewStartSectionResponse = {
  QualificationSurveySectionResponse: {
    section: Section;
    sectionId: string;
    __typename: 'QualificationSurveySectionResponsesV2';
  };
  errors: unknown;
};

export type PreviewStartSectionVariables = {
  productId: string;
  surveyVariantParam: string;
  input: Record<string, unknown>;
};

export const getPreviewStartSectionVariables = ({
  productId,
  surveyVariant,
}: {
  productId: string;
  surveyVariant?: string;
}): PreviewStartSectionVariables => ({
  productId,
  surveyVariantParam: surveyVariant ? `&surveyVariant=${encodeURIComponent(surveyVariant)}` : '',
  input: {},
});

export const PREVIEW_START_SECTION = gql`
  mutation PreviewStartSection($productId: String!, $surveyVariantParam: String, $input: DataMap) {
    QualificationSurveySectionResponse(productId: $productId, surveyVariantParam: $surveyVariantParam, input: $input)
      @rest(
        type: "QualificationSurveySectionResponsesV2"
        path: "qualificationSurveySectionResponses.v2?action=previewStartSection&productId={args.productId}{args.surveyVariantParam}"
        method: "POST"
      ) {
      sectionId
      section {
        typeName
        definition {
          title
          questions
          nextMessage
        }
      }
    }
  }
`;
